import React, { useState, useEffect } from "react";

export const InsuranceInfoNormal = ({ contractInsuranceCondition, onUpdate, contractIndex, disabled = false, showToast }) => {
    const applicableAgeOptions = [
        { value: 21, label: "만 21세 이상" },
        { value: 24, label: "만 24세 이상" },
        { value: 26, label: "만 26세 이상" },
    ];

    const handleAgeChange = (age) => {
        if (!disabled) {
            onUpdate("applicableAge", age);
        }
    };

    return (
        <>
            <div className="item-row" data-grow="1">
                <div className="row-head">
                    <span>보험 가입 연령</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        {applicableAgeOptions.map((option) => (
                            <div key={option.value} className="radiobox">
                                <input
                                    type="radio"
                                    name={`applicableAge_${contractIndex}`}
                                    id={`applicableAge_${option.value}_${contractIndex}`}
                                    checked={contractInsuranceCondition?.applicableAge === option.value}
                                    onChange={() => handleAgeChange(option.value)}
                                    disabled={disabled}
                                />
                                <label htmlFor={`applicableAge_${option.value}_${contractIndex}`}>
                                    {option.label}
                                </label>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};
